// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"Checkbox_checkboxWrapper__u86+1","checkbox":"Checkbox_checkbox__rNB6E","circle":"Checkbox_circle__0rTj3"};